import { useTranslation } from 'react-i18next'
import { KILO } from '../../constants/KILO_THEME'

type ActiveCalendarEducationProps = {
  onConnect?: () => void
  unlockHint?: string | null
  embedded?: boolean
}

const ActiveCalendarEducation = ({
  onConnect,
  unlockHint,
  embedded = false,
}: ActiveCalendarEducationProps) => {
  const { t } = useTranslation()

  const shell = embedded
    ? KILO.embeddedSection
    : 'rounded-2xl border border-kilo-accent/15 bg-kilo-card p-5'

  return (
    <div className={shell}>
      {!embedded ? (
        <>
          <p className="text-xs font-bold uppercase tracking-widest text-kilo-accent/80">
            {t('coach.activeCalendar.badge')}
          </p>
          <h3 className={`mt-2 text-base font-semibold ${KILO.text.primary}`}>
            {t('coach.activeCalendar.title')}
          </h3>
        </>
      ) : null}
      <div className={`space-y-3 text-sm leading-relaxed ${KILO.text.primary} ${embedded ? '' : 'mt-3'}`}>
        <p>{t('coach.activeCalendar.paragraph1')}</p>
        <p>{t('coach.activeCalendar.paragraph2')}</p>
        <p>{t('coach.activeCalendar.paragraph3')}</p>
        <p className={KILO.text.muted}>{t('coach.activeCalendar.paragraph4')}</p>
      </div>
      {unlockHint ? <p className={`mt-3 text-xs ${KILO.text.soft}`}>{unlockHint}</p> : null}
      {onConnect ? (
        <button
          type="button"
          onClick={onConnect}
          className="mt-4 w-full rounded-xl bg-kilo-accent py-2.5 text-sm font-semibold text-black transition-colors hover:bg-kilo-accent-dark"
        >
          {t('coach.activeCalendar.connectButton')}
        </button>
      ) : null}
    </div>
  )
}

export default ActiveCalendarEducation
